import { Box, BoxProps, SxProps } from "@mui/material";

type Props = BoxProps & {
  src: string;
  alt?: string;
  sx?: SxProps;
};

export const Image = (props: Props) => {
  return (
    <Box {...props} sx={props.sx} width={1} component="img" src={props.src} />
  );
};
